import {
  useGetAdminAnnouncements,
  usePostAdminAnnouncements,
  usePutAdminAnnouncementsId,
  useDeleteAdminAnnouncementsId,
  getGetAdminAnnouncementsQueryKey,
  type GetAdminAnnouncementsParams,
  type AdminCreateAnnouncementRequest,
  type AdminUpdateAnnouncementRequest,
} from '@/types/origin-point-engine'
import type { AdminGetAnnouncementsResponse } from '../types/admin-announcement'

/**
 * 获取管理员公告列表的 Hook 封装
 */
export function useAdminAnnouncementsList(
  params?: GetAdminAnnouncementsParams
) {
  return useGetAdminAnnouncements<AdminGetAnnouncementsResponse>(params)
}

/**
 * 创建公告的 Mutation Hook
 */
export function useCreateAnnouncementMutation() {
  return usePostAdminAnnouncements()
}

/**
 * 更新公告的 Mutation Hook
 */
export function useUpdateAnnouncementMutation() {
  return usePutAdminAnnouncementsId()
}

/**
 * 删除公告的 Mutation Hook
 */
export function useDeleteAnnouncementMutation() {
  return useDeleteAdminAnnouncementsId()
}

// 重新导出类型和工具函数
export {
  getGetAdminAnnouncementsQueryKey,
  type GetAdminAnnouncementsParams,
  type AdminCreateAnnouncementRequest,
  type AdminUpdateAnnouncementRequest,
}
